import './assets/main.css'

import { createApp, reactive  } from 'vue'
import router from './router'
import { createI18n } from "vue-i18n";
import App from './App.vue'
import store from '../store/index.js';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.scss';
import "bootstrap"

import BasicHelper from "./helpers/BasicHelper.js";
import ApiRequest from '@/helpers/ApiRequest.js';
import spinner from "@/components/spinner/spinner.vue";
import en from "@/locales/en.json"
import lv from "@/locales/lv.json"

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import tooltip from "@/assets/tooltip.js";
import "@/assets/tooltip.css";
import BModal from '@/components/common/modalwindow.vue';

const app = createApp(App)

const i18n = createI18n({
    legacy: false,
    locale: 'en',
    messages: { en, lv }
})
app.directive("tooltip", tooltip);
app.component('DatePicker', VueDatePicker);
app.component('spinner', spinner);
app.component('BModal', BModal);

app.use(router)
app.use(i18n)
app.use(store)
app.use({
    install(app) {
        app.config.globalProperties.ApiRequest = ApiRequest
        app.config.globalProperties.BasicHelper = BasicHelper
    }
})

store.dispatch('initStore')
store.dispatch('checkPermission')

app.mount('#app')
